import React, { useId } from 'react';

export default function FormInput({
  label,
  value,
  onChange,
  type = 'text',
  autoComplete,
  placeholder,
  enterKeyHint,
  id,
  inputClassName = 'commanding-input',
  wrapperClassName = 'auth-field',
  labelClassName = 'auth-field-label'
}: {
  label: string;
  value: string;
  onChange: (next: string) => void;
  type?: string;
  autoComplete?: string;
  placeholder?: string;
  /** What the phone keyboard's return key says: "next" between fields, "go" on the last one. */
  enterKeyHint?: React.InputHTMLAttributes<HTMLInputElement>['enterKeyHint'];
  id?: string;
  inputClassName?: string;
  wrapperClassName?: string;
  labelClassName?: string;
}) {
  const generatedId = useId();
  const inputId = id || generatedId;
  // An address is never a sentence: without these, iOS capitalises its first letter and offers to
  // "correct" it. `type="email"` alone brings up the keyboard with @ but does not stop either.
  const isEmail = type === 'email';

  return (
    <div className={ wrapperClassName }>
      <label htmlFor={ inputId } className={ labelClassName }>{ label }</label>
      <input
        id={ inputId }
        className={ inputClassName }
        value={ value }
        onChange={ (e) => onChange(e.target.value) }
        type={ type }
        autoComplete={ autoComplete }
        placeholder={ placeholder }
        enterKeyHint={ enterKeyHint }
        autoCapitalize={ isEmail ? 'none' : undefined }
        autoCorrect={ isEmail ? 'off' : undefined }
        spellCheck={ isEmail ? false : undefined }
      />
    </div>
  );
}
